export default {"src":"/_next/static/media/rambutan.085055c6.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};